const documentHeight = () => {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};
const documentWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
export default {
    documentHeight,
    documentWidth
};
